import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-integrator-settings',
  templateUrl: './integrator-settings.component.html',
  styleUrls: ['./integrator-settings.component.scss']
})
export class IntegratorSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
